export default {"src":"/_next/static/media/flexible-eligibility.30ff041b.svg","height":184,"width":227};